<template>
  <!-- 组件 -->
  <div>
    <div class="proService">
      <div class="company_title" @click="selTabber(1)">
        产品与服务
      </div>
      <div class="company_warn">
        为建筑垃圾行业提供全生命周期咨询+信息化+业务运营服务
      </div>
      <div class="product_service">
        <div class="is_consulting product" @click="goService(0)" :class="{'is_consulting':selectId===0,'is_product':selectId===0}">
          <div class="product" :class="{'is_product':selectId===0}">
            <div class="product_text" v-if="selectId!==0">
              咨询服务
            </div>
            <div class="product_title" v-if="selectId===0">
              咨询服务
            </div>
            <div class="product_word" v-if="selectId===0">
              依托公司多年建筑垃圾行业从业经验，提供建筑垃圾全过程产业化经营咨询服务，包括流程设计与优化、运营方案、消纳与处置、信息化等
            </div>
          </div>
        </div>
        <div class="is_platform product" @click="goService(1)" :class="{'is_platform':selectId===1,'is_product':selectId===1}">
          <div class="product" :class="{'is_product':selectId===1}">
            <div class="product_text" v-if="selectId!==1">
              平台研发
            </div>
            <div class="product_title" v-if="selectId===1">
              平台研发
            </div>
            <div class="product_word" v-if="selectId===1">
              采用物联网、大数据、人工智能等先进技术，为客户提供平台定制服务，包括物联网+监管平台、物联网+运营平台、物联网+运输管理平台等
            </div>
          </div>
        </div>
        <div class="is_IOT_hardware product" @click="goService(2)" :class="{'is_IOT_hardware':selectId===2,'is_product':selectId===2}">
          <div class="product" :class="{'is_product':selectId===2}">
            <div class="product_text" v-if="selectId!==2">
              物联硬件
            </div>
            <div class="product_title" v-if="selectId===2">
              物联硬件
            </div>
            <div class="product_word" v-if="selectId===2">
              提供渣土车、冷链运输车等智能装备的销售、安装及售后服务，支持实时定位、视频监控、驾驶员状态监测、盲区监测等功能
            </div>
          </div>
        </div>
        <div class="is_operate product" @click="goService(3)" :class="{'is_operate':selectId===3,'is_product':selectId===3}">
          <div class="product" :class="{'is_product':selectId===3}">
            <div class="product_text" v-if="selectId!==3">
              运营服务
            </div>
            <div class="product_title" v-if="selectId===3">
              运营服务
            </div>
            <div class="product_word" v-if="selectId===3">
              依托多年建筑垃圾行业工地管理、运输、资源化处置经验，为客户提供建筑垃圾全周期业务代运营服务
            </div>
          </div>
        </div>
        <div class="is_increment product" @click="goService(4)" :class="{'is_increment':selectId===4,'is_product':selectId===4}">
          <div class="product" :class="{'is_product':selectId===4}">
            <div class="product_text" v-if="selectId!==4">
              增值服务
            </div>
            <div class="product_title" v-if="selectId===4">
              增值服务
            </div>
            <div class="product_word" v-if="selectId===4">
              公司联合软件、硬件、保险、金融等合作伙伴，搭建行业生态圈，为平台会员提供金融保险、征信档案、撬装加油、车后市场等增值服务
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    selectId:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    goService(e){
      this.$emit('goService',e)
    },
    selTabber(e){
      this.$emit('selTabber',e)
    },
  },
};
</script>

<style scoped lang="scss">
@import url(../home.css);
@media screen and ( min-width: 1200px ) {
  .proService{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .product_service{
    width: 1920px;
    padding: 0 360px;
    display: flex ;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    background-image: url('/static/img/index/landscape.png');
    background-size: cover;
    box-sizing: border-box;
    .product{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 201px;
      height: 438px;
      background: rgba(0, 0, 0, 0.5);
      font-size: 28px;
      font-weight: bold;
      color: #FFFFFF;
      background-size: cover;
      cursor:pointer;
      transition : all 0.8s ease-in-out;
      background-position:center;
    }
    .is_product{
      width: 384px;
      height: 438px;
      background: rgba(14, 160, 73, 0.7);
      background-size: cover;
      flex-direction: column;
      align-items: flex-start;
    }
    .is_consulting{
      background-image: url('/static/img/index/consultingServiceB.png');
    }
    .is_platform{
      background-image: url('/static/img/index/platformB.png');
    }
    .is_IOT_hardware{
      background-image: url('/static/img/index/IOTB.png');
    }
    .is_operate{
      background-image: url('/static/img/index/operateB.png');
    }
    .is_increment{
      background-image: url('/static/img/index/incrementB.png');
    }
    .product_text{
      width: 32px;
    }
    .product_title{
      font-weight: bold;
      font-size: 20px;
      line-height: 120%;
      color: #FFFFFF;
      text-align: left;
      margin-left: 30px;
      letter-spacing: 0.08em;
    }
    .product_word{
      text-align: justify;
      font-weight: 400;
      margin-top: 40px;
      margin-left: 30px;
      width: 324px;
      font-size: 14px;
      line-height: 24px;
      color: #FFFFFF;
      letter-spacing: 0.08em;
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .proService{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .product_service{
    width: 120rem;
    padding: 0 22.5rem;
    display: flex ;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.875rem;
    background-image: url('/static/img/index/landscape.png');
    background-size: cover;
    box-sizing: border-box;
    .product{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12.5625rem;
      height: 27.375rem;
      background: rgba(0, 0, 0, 0.5);
      font-size: 1.75rem;
      font-weight: bold;
      color: #FFFFFF;
      background-size: cover;
      cursor:pointer;
      transition : all 0.8s ease-in-out;
      background-position:center;
    }
    .is_product{
      width: 24rem;
      height: 27.375rem;
      background: rgba(14, 160, 73, 0.7);
      background-size: cover;
      flex-direction: column;
      align-items: flex-start;
    }
    .is_consulting{
      background-image: url('/static/img/index/consultingServiceB.png');
    }
    .is_platform{
      background-image: url('/static/img/index/platformB.png');
    }
    .is_IOT_hardware{
      background-image: url('/static/img/index/IOTB.png');
    }
    .is_operate{
      background-image: url('/static/img/index/operateB.png');
    }
    .is_increment{
      background-image: url('/static/img/index/incrementB.png');
    }
    .product_text{
      width: 2rem;
    }
    .product_title{
      font-weight: bold;
      font-size: 1.25rem;
      line-height: 1.5rem;
      color: #FFFFFF;
      text-align: left;
      margin-left: 1.875rem;
      letter-spacing: 0.08em;
    }
    .product_word{
      text-align: justify;
      font-weight: 400;
      margin-top: 2.5rem;
      margin-left: 1.875rem;
      width: 20.25rem;
      font-size: .875rem;
      line-height: 1.5rem;
      color: #FFFFFF;
      letter-spacing: 0.08em;
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .proService{
    background-color: #F6FAFD;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: .625rem;
    .product_service{
      width: 23.4375rem;
      padding: 0 1rem;
      display: flex ;
      align-items: center;
      justify-content: space-between;
      margin-top: .625rem;
      box-sizing: border-box;
      .product{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.5625rem;
        height: 10rem;
        background: rgba(0, 0, 0, 0.5);
        font-size: .875rem;
        font-weight: bold;
        color: #FFFFFF;
        background-size: cover;
        cursor:pointer;
      }
      .is_product{
        width: 6.6875rem;
        height: 10rem;
        background: rgba(14, 160, 73, 0.7);
        background-size: cover;
        flex-direction: column;
        align-items: flex-start;
      }
      .is_consulting{
        background-image: url('/static/img/index/consultingServiceB.png');
      }
      .is_platform{
        background-image: url('/static/img/index/platformB.png');
      }
      .is_IOT_hardware{
        background-image: url('/static/img/index/IOTB.png');
      }
      .is_operate{
        background-image: url('/static/img/index/operateB.png');
      }
      .is_increment{
        background-image: url('/static/img/index/incrementB.png');
      }
      .product_text{
        width: .625rem;
      }
      .product_title{
        font-weight: bold;
        font-size: .875rem;
        font-weight: 600;
        line-height: 120%;
        color: #FFFFFF;
        text-align: left;
        margin-left: .625rem;
        letter-spacing: 0.08em;
      }
      .product_word{
        // text-align: justify;
        font-weight: 400;
        margin-top: .375rem;
        margin-left: .625rem;
        width: 5.1875rem;
        font-size: .75rem;
        line-height: 1rem;
        color: #FFFFFF;
        letter-spacing: 0.08em;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index/components/home-service.vue